// Dynamic API URL configuration
// Uses the current domain in production, falls back to env variable in development

const getApiUrl = () => {
  // In production, use the same domain as the frontend
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Production domains - use same domain for API
    if (hostname === 'drivemaster.se' || hostname === 'www.drivemaster.se') {
      return 'https://drivemaster.se';
    }
    
    // Emergent preview/production hosts - use same origin
    if (hostname.includes('.emergent.host') || hostname.includes('.emergentagent.com')) {
      return window.location.origin;
    }
  }
  
  // Development/fallback - use environment variable
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
};

export const API_URL = getApiUrl();
export const API = `${API_URL}/api`;

export default { API_URL, API };
